import React from "react";
import { FC, useState } from "react";
import { Typography } from "@material-ui/core";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import CalendarPicker from "../../../components/portico/calendar-picker/calendar-picker";
import { useDispatch } from "react-redux";
import { setSnackBar } from "../../../stores/ui/ui-action";
import { useStyles } from "./styles";
import { addCompanyDetails } from "../../../services/bff-service";

export const AddCompany: FC<any> = ({ open, onClose }) => {
  const styles = useStyles();
  const dispatch = useDispatch();

  const [companyName, setCompanyName] = useState("");
  const [companyId, setCompanyId] = useState("");
  const [fyEndDate, setFyEndDate] = useState("");
  const [errors, setErrors] = useState({ companyName: '', companyId: '', fyEndDate: '' });
  const inputFormat = "MM/yyyy";
  const requiredMessage = { companyName: 'Company Legal Name is required', companyId: 'Codat ID is required', fyEndDate: 'FY End Date is required' };

  const currentYearDate = new Date();
  const previousYearDate = new Date(currentYearDate.setDate(0));
  previousYearDate.setFullYear(currentYearDate.getFullYear() - 1);

  const handleChange = (event: any) => {
    const { name, value } = event.target;

    switch (name) {
      case 'companyName':
        setCompanyName(value);
        validateField(name, value);
        break;
      case 'companyId':
        setCompanyId(value);
        validateField(name, value);
        break;
      default:
        break;
    }
  };

  const handleDateChange = (event: any) => {
    let lastDateOfMonth = new Date(event?.getFullYear(), event?.getMonth() + 1, 0).toLocaleDateString("sv-SE");
    setFyEndDate(lastDateOfMonth);
  }

  const validateField = (fieldName: string, fieldValue: string) => {
    switch (fieldName) {
      case 'companyName':
        setErrors({ ...errors, companyName: '' });
        if (!fieldValue) { setErrors({ ...errors, companyName: requiredMessage.companyName }) }
        break;
      case 'companyId': {
        setErrors({ ...errors, companyId: '' });
        if (!fieldValue) { setErrors({ ...errors, companyId: requiredMessage.companyId }) }
        const regex = new RegExp(
          /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i
        );
        const isValid = fieldValue.match(regex);
        if (!isValid) { setErrors({ ...errors, companyId: 'Codat ID is invalid' }) }
        break;
      }
      default:
        return null;
    }
  }

  const validateForm = () => {
    const companyNameError = companyName ? '' : requiredMessage.companyName;
    const companyIdError = companyId ? '' : requiredMessage.companyId;
    const fyEndDateError = fyEndDate ? '' : requiredMessage.fyEndDate;

    setErrors({ companyName: companyNameError, companyId: companyIdError, fyEndDate: fyEndDateError });

    return !(companyNameError || companyIdError || fyEndDateError);
  }

  const resetFields = () => {
    setCompanyName('');
    setCompanyId('');
    setFyEndDate('');
    setErrors({ companyName: '', companyId: '', fyEndDate: '' });
  }

  const handleClose = () => {
    resetFields();
    onClose();
  };


  const handleSubmit = async () => {
    const isValid = validateForm();
    if (isValid) {
      const payload = { companyId: companyId, companyName: companyName, fyEndDate: fyEndDate }
      try {
        await addCompany(payload);
      } catch (error) {
        throwError(error);
      }
    }
  };

  const addCompany = async (payload: any) => {
    const response = await addCompanyDetails(payload);
    if (!!response.status) {
      dispatch(setSnackBar({ show: true, message: "Success", description: response.message, messageType: "success" }));
    }
    handleClose();
  };

  const throwError = (error: any) => {
    if (error?.response?.status === 409) {
      dispatch(setSnackBar({ show: true, message: "Error", description: error.response.data.error.message, messageType: "error" }));
    } else {
      dispatch(setSnackBar({ show: true, message: "Error", description: error.message, messageType: "error" }));
    }
  }

  return (
    <>
      <Modal open={open} onClose={onClose} aria-labelledby="modal-add-company" data-testid="modal-add-company">
        <Box className={styles.wrapper}>
          <Typography id="typo-add-company" variant="h6" component="h3" className={styles.companyHeading}>Add Company</Typography>
          <TextField
            label="Company Legal Name"
            variant="outlined"
            placeholder="Company Legal Name"
            className={styles.textField}
            name='companyName'
            value={companyName}
            onChange={handleChange}
            error={Boolean(errors.companyName)}
            helperText={errors.companyName}
            required
          />
          <TextField
            label="Codat ID"
            variant="outlined"
            placeholder="Codat ID"
            name='companyId'
            value={companyId}
            onChange={handleChange}
            error={Boolean(errors.companyId)}
            helperText={errors.companyId}
            className={styles.textField}
            required
          />
          <Box className={styles.textField}>
            <CalendarPicker
              name="fyEndDate"
              label="FY End Date"
              inputFormat={inputFormat}
              views={
                inputFormat === "MM/yyyy"
                  ? ["year", "month"]
                  : ["year", "month", "day"]
              }
              setValue={() => { }}
              value={""}
              minDate={previousYearDate}
              maxDate={currentYearDate}
              onChange={handleDateChange}
              required
            />
          </Box>
          <Box className={styles.companyFooter}>
            <Button variant="text" className={styles.cancel} onClick={handleClose}>cancel</Button>
            <Button variant="text" className="default" type='submit' onClick={handleSubmit}>add company</Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};
